import Widget from '../modules/widget';
import Dropdown from '../modules/dropdown';

export default {
  init() {
    // CATEGORY WIDGET ON MOBILE

    const categoryWidget = new Widget('.widget_product_categories', '.js-open-category-widget', 'widget-opened');
    categoryWidget.toggleWidget();

    // CATEGORY WIDGET - SUBCATEGORIES DROPDOWN

    const categoryChildrenDropdown = new Dropdown('.cat-parent', 'subcategory-opened');
    categoryChildrenDropdown.toggleDropdown();

  },
  finalize() {

  },
};


// WEBPACK FOOTER //
// ./scripts/routes/templateRecent.js